import { cdnIcon } from "../../exam-prep/common/cdnIcon.jsx";

// dMAT icons (s3://<bucket>/public/dmat/icons/), baked in dMAT's colour.
const img = cdnIcon("https://cdn.nbyula.com/public/dmat/icons");

export const ArrowUpRight = img("arrow-up-right");
export const X = img("x");
export const LockKeyhole = img("lock-keyhole");
export const Check = img("check");
export const BookOpen = img("book-open");
export const ArrowLeft = img("arrow-left");
export const Bookmark = img("bookmark");
export const Timer = img("timer");
export const Coffee = img("coffee");
export const ChevronDown = img("chevron-down");
export const LogOut = img("log-out");
export const ChevronRight = img("chevron-right");
export const Search = img("search");
export const Play = img("play");
export const Menu = img("menu");
export const Download = img("download");
export const CreditCard = img("credit-card");
export const LoaderCircle = img("loader-circle");
export const ArrowRight = img("arrow-right");
export const Flag = img("flag");
export const Maximize = img("maximize");
export const CircleCheck = img("circle-check");
export const LayoutDashboard = img("layout-dashboard");
export const Shapes = img("shapes");
export const ChartNoAxesCombined = img("chart-no-axes-combined");
export const CirclePlay = img("circle-play");
export const Target = img("target");
export const Flame = img("flame");
export const CheckCheck = img("check-check");
export const Sigma = img("sigma");
export const Grid2X2 = img("grid-2x2");
export const ListChecks = img("list-checks");
export const WifiOff = img("wifi-off");
export const Trophy = img("trophy");
